import SuccessSummary from './success_summary';

export default SuccessSummary;
